import { Trash2 } from 'lucide-react';
import type { JSONContent } from '@tiptap/react';
import { DossierEditor } from '../editor';

interface Annotation {
  id: string;
  after_item_id: string | null;
  content: JSONContent;
}

export function AnnotationCard({
  annotation,
  onUpdate,
  onDelete,
}: {
  annotation: Annotation;
  onUpdate: (id: string, content: JSONContent) => void;
  onDelete: (id: string) => void;
}) {
  return (
    <div className="relative group">
      <div className="border-l-2 border-accent/30 pl-3">
        <DossierEditor
          content={annotation.content}
          onUpdate={(content) => onUpdate(annotation.id, content)}
          editable={true}
          placeholder="Write a note..."
        />
      </div>
      <button
        onClick={() => onDelete(annotation.id)}
        className="absolute -top-1 -right-1 opacity-0 group-hover:opacity-100 p-1 bg-bg-surface border border-border rounded text-text-muted hover:text-danger transition-all"
        title="Remove annotation"
      >
        <Trash2 size={12} />
      </button>
    </div>
  );
}
